import { useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { updatePlayer } from '@/lib/api';
import type { Player } from '@swiss-magic/shared-types';

interface UseNotesDialogParams {
  tournamentId: string | undefined;
  setPlayers: Dispatch<SetStateAction<Player[]>>;
}

export function useNotesDialog({ tournamentId, setPlayers }: UseNotesDialogParams) {
  const [notesTarget, setNotesTarget] = useState<Player | null>(null);
  const [notesText, setNotesText] = useState('');

  async function handleSaveNotes() {
    if (!notesTarget || !tournamentId) return;
    const updated = await updatePlayer(tournamentId, notesTarget.id, {
      notes: notesText.trim() || null,
    });
    setPlayers((prev) => prev.map((p) => (p.id === updated.id ? updated : p)));
    setNotesTarget(null);
  }

  return {
    notesTarget,
    setNotesTarget,
    notesText,
    setNotesText,
    handleSaveNotes,
  };
}
